// preview 專用：消息 Tab 面板（最新消息／活動快訊／系統公告），取代原本三段直疊。
import { useState } from "react";
import { NEWS_TABS } from "./home_page_v2_demo_data";

const DemoNewsTabs = () => {
  const [active, setActive] = useState(NEWS_TABS[0].key);
  const tab = NEWS_TABS.find((t) => t.key === active) || NEWS_TABS[0];

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        overflow: "hidden",
      }}
    >
      <div style={{ display: "flex", borderBottom: "2px solid #eef2f7" }}>
        {NEWS_TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setActive(t.key)}
            style={{
              flex: 1,
              padding: "0.9rem 0.5rem",
              fontWeight: 700,
              fontSize: "1rem",
              color: active === t.key ? "#1e3a8a" : "#94a3b8",
              borderBottom:
                active === t.key ? "3px solid #fa8c16" : "3px solid transparent",
              background: active === t.key ? "#f8fafc" : "transparent",
              cursor: "pointer",
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div style={{ padding: "0.25rem 1rem" }}>
        {tab.items.map((it, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              gap: "0.9rem",
              padding: "0.9rem 0.2rem",
              borderBottom:
                i < tab.items.length - 1 ? "1px solid #f1f5f9" : "none",
              alignItems: "baseline",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                flexShrink: 0,
                color: "#fa8c16",
                fontWeight: 700,
                fontSize: "0.85rem",
                width: "62px",
              }}
            >
              {it.date}
            </span>
            <div>
              <div style={{ fontWeight: 600, color: "#1e293b" }}>{it.title}</div>
              <div style={{ color: "#64748b", fontSize: "0.9rem", marginTop: "2px" }}>
                {it.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemoNewsTabs;
